import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

export const StyledThemeDetail = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    h1 {
      display: flex;
      align-items: center;

      .back {
        margin-right: 10px;
        font-size: 20px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;

        :hover {
          color: ${Colors.primary};
        }
      }
    }
  }

  .ant-spin-nested-loading,
  .ant-spin-container {
    height: 100%;
    position: relative;
  }

  .activity-detail {
    display: flex;

    .activity-preview {
      flex: 1;
      height: ${({ isLibrary }) => (isLibrary ? '55vh' : '45vh')};
      background-color: ${({ isLibrary }) =>
        isLibrary ? 'white' : Colors.backgroundPalerBlueDark};
      border-radius: 10px 10px 0 0;
      border: 1px solid
        ${({ isLibrary }) =>
          isLibrary ? Colors.evenLighterGray : `${Colors.darkBlue}11`};
      border-bottom: none;
      padding: 20px 20px 0;
    }

    .activity-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      transition: all 0.3s;

      .activity-description {
        flex: 1;
        padding: 0 40px 10px;
        p {
          font-size: 115%;
        }
      }

      .activity-buttons {
        display: flex;
        flex-direction: column;
        gap: 5px;
        justify-content: flex-end;
        padding: 0px 40px 10px 40px;

        > * {
          width: 100%;
        }

        .added-tag {
          text-align: center;
        }

        .edit-theme-button {
          color: ${Colors.darkBlue};
          border-color: ${Colors.darkBlue};

          :hover {
            color: ${Colors.darkBlue}BB;
            border-color: ${Colors.darkBlue}BB;
          }
        }
      }
    }
  }

  .activities-container {
    background-color: white;
    margin-top: -1px;

    background-color: ${({ isLibrary }) =>
      isLibrary ? 'white' : Colors.backgroundPalerBlueDark};
    border: 1px solid
      ${({ isLibrary }) =>
        isLibrary ? Colors.evenLighterGray : `${Colors.darkBlue}11`};
    width: 100%;
    padding: 25px 10px 20px;
    border-radius: 0px 10px 10px 10px;
  }

  .public-description {
    margin-top: 50px;
    max-width: 100%;

    img {
      max-width: 100% !important;
      height: auto !important;
    }
  }

  &.expanded-screen {
    .activity-preview {
      height: 75vh;
    }

    .activity-detail {
      .activity-info {
        flex: 0;
        width: 0;

        > * {
          display: none;
        }
      }
    }

    .activities-container {
      padding: 10px;
      border-radius: 0 0 10px 10px;
    }
  }

  @media (max-width: ${MediaQueryBreakpoints.md}) {
    .theme-activities-and-preview {
      box-shadow: ${Colors.boxShadow};
      border-radius: 10px;
      overflow: hidden;

      .activity-detail {
        flex-direction: column;
        flex-flow: column-reverse;

        .activity-preview {
          height: 45vh;
          flex: unset;
          box-shadow: none;
          border-radius: 0;
          margin-bottom: 10px;
          &:has(> .video) {
            max-height: 30vh;
          }
        }
      }

      .activities-container {
        border-radius: 0;
        box-shadow: none;
        padding-bottom: 5px;

        .activity:last-child {
          border: none;
        }
      }
    }

    .public-description {
      img {
        width: 100% !important;
        height: auto !important;
      }
    }
  }
`;
